import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';
import {USER_COOKIE} from "../lib/constants";

let userObject = {
    id: null,
    name: null,
    email: null,
    token: null,
};

const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    getToken: () => {
        return userObject.token || '';
    },

    acronym : () => {
        if (!userObject.name) {
            return '';
        }
        return userObject.name.split(' ').map(function(item){return item[0]}).join('');
    },

    initialize: () => {
        user.update(obj => {
            obj.token = cookie.get(USER_COOKIE) || null;
            return obj;
        });
    },

    setUser: data => {
        user.update(obj => {
            obj.id = data.id;
            obj.name = data.name;
            obj.email = data.email;
            obj.token = data.token;
            user.saveCookie();
            return obj;
        });
    },

    clearToken: () => {
        user.update(obj => {
            obj.token = null;
            user.saveCookie();
            return obj;
        });
    },

    saveCookie: () => {
        cookie.create(USER_COOKIE, userObject.token);
    },
}

export default user;